import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import DistributorWhitelistTable from "./DistributorWhitelist-Table"

const DistributorWhitelistDashboard = props => {
  const themeColor = useSelector(state => state.theme.color)

  useEffect(() => {
    document.documentElement.style.setProperty("--scrollbar-color", themeColor)
  }, [themeColor])

  document.title = "Distributor Whitelist - ColdBlock Technologies Inc."

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              <DistributorWhitelistTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

DistributorWhitelistDashboard.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(DistributorWhitelistDashboard)
